import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../api/axiosBaseQuery";

export const eventApi: any = createApi({
  reducerPath: "eventApi",
  baseQuery: axiosBaseQuery(),
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getEvents: builder.query<
      any,
      {
        is_active?: boolean;
        event_type?: string;
        city?: string;
        sort_by?: string;
        limit?: number;
        offset?: number;
      }
    >({
      query: ({ is_active, event_type, city, sort_by, limit, offset }) => ({
        url: `/event`,
        method: "GET",
        params: {
          is_upcoming: is_active,
          event_type: event_type,
          city: city,
          sort_by: sort_by,
          event_limit: limit,
          event_offset: offset,
        },
      }),
    }),
    getEventById: builder.query<any, { id: string }>({
      query: ({ id }) => ({
        url: `/event/${id}`,
        method: "GET",
      }),
      transformResponse: (response: any) => response?.data?.event,
    }),
    getMyEvents: builder.query<any, void>({
      query: () => ({
        url: `/event/my`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetEventsQuery,
  useGetMyEventsQuery,
  useLazyGetEventByIdQuery,
} = eventApi;
